module.exports = __webpack_public_path__ + "static/media/icon-search.bb0aee6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/home-navbar/navbar-search/icon-search.svg
// module id = 368
// module chunks = 0 1 2